import { useMemo } from "react";
import { useLocation } from "react-router-dom";

const DEFAULT_LANGUAGE = "ja";

export const useUrlParams = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  return useMemo(() => {
    const soulId = queryParams.get("soul_id");
    return {
      soulId,
      lng: queryParams.get("lng") || DEFAULT_LANGUAGE,
      work: location.pathname.split("/")[1],
      character: soulId?.split("_")[0],
    };
  }, [location]);
};
